<template>
  <div class="input" v-if="autoEntry">
    <div class="button-warning">
      自動承認対象のイベントです！
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    autoEntry: {
      get: function () {
        return this.$store.state.event.autoEntry
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';

.button-warning {
  @include button-ol-base;
  margin-left: 20px;
  margin-right: 20px;
  cursor: default;
  border: none;
  background: $orange;
  color: black;
}
</style>
